import customAxios from "./axios";
import CONFIG from "../../config";

export const getAllForms = () => {
  return customAxios.get(CONFIG.apiURL + "/Forms").then((res) => {
    let response = res["data"];
    return response;
  });
};

export const getAllServices = () => {
  return customAxios
    .get(CONFIG.apiURL + "/Departments/Services")
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const formMapping = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/Forms/Mapping", payload)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const listAllUserContainers = () => {
  return customAxios
    .get(CONFIG.documentURL + "/DocumentVault/Document/ListAllContainers")
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const formDelete = (id) => {
  return customAxios
    .delete(CONFIG.apiURL + `/Jobs/DeleteDraft/${id}`)
    .then((res) => {
      return res;
    });
};
